import { Note } from '../types';

/** Notes remain visible after their author's user row is deleted. */
export const noteAuthor = (note: Note): string =>
  note.creator_email || `Former user (ID ${note.user_id})`;
